import React, { useEffect } from 'react';
import { KiteLoader } from '@kite/react-kite';
import {
  useAnalytics,
  useGetEstimateDetails,
  useGetTcoDiyProducts,
  useGetTcoSpectrumProducts,
  useGetTcoSections,
  useGetTcoForms,
} from 'hooks';
import { useParams } from 'react-router-dom';
import { TCOLayout } from 'components/pageLayout';

// Styles
import './TCOPage.scss';
import { useGetTcoDeviceSelections } from 'hooks/apiHooks/useGetTcoDeviceSelections';

const TCOPage = () => {
  // =============================================
  // State/Refs/Hooks
  // =============================================
  const { trackPageView } = useAnalytics();
  const { estimateId } = useParams();
  const {
    estimateData,
    estimateLoading,
    error: estimateError,
  } = useGetEstimateDetails(estimateId);

  // Making this call to fetch products data in TCO page
  const { isLoading: spectrumProductsLoading, isError: spectrumProductsError } =
    useGetTcoSpectrumProducts();

  const { isLoading: diyProductsLoading, isError: diyProductsError } =
    useGetTcoDiyProducts();

  const {
    data: sectionsData,
    isLoading: sectionsLoading,
    error: sectionError,
  } = useGetTcoSections();

  const {
    data: formsData,
    isLoading: formsLoading,
    error: formsError,
  } = useGetTcoForms();

  const {
    isLoading: tcoDeviceSelectionsLoading,
    error: tcoDeviceSelectionsError,
  } = useGetTcoDeviceSelections({
    params: { estimateId: estimateId },
  });

  const isTcoPageError =
    !!estimateError ||
    !!spectrumProductsError ||
    !!diyProductsError ||
    !!tcoDeviceSelectionsError ||
    !!sectionError ||
    !!formsError;

  // =============================================
  // Effects
  // =============================================
  useEffect(() => trackPageView('TCOPage'), [trackPageView]);

  // =============================================
  // Early Return
  // =============================================

  if (
    estimateLoading ||
    spectrumProductsLoading ||
    diyProductsLoading ||
    tcoDeviceSelectionsLoading ||
    sectionsLoading ||
    formsLoading
  ) {
    return (
      <div className="display-loader">
        <KiteLoader loaderTitle="Loading TCO Tool" />
      </div>
    );
  }

  if (isTcoPageError) {
    return <div>Something went wrong</div>;
  }

  // =============================================
  // Return
  // =============================================
  return (
    <TCOLayout
      estimate={estimateData}
      sections={sectionsData}
      forms={formsData}
    />
  );
};

export default TCOPage;
